import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setNumberValue } from "../redux/slices/numberSlice";
import InfoTooltip from "./Tooltip";

const NumericInput = ({ label, stateName, tooltip, error }) => {
  const dispatch = useDispatch();
  const value = useSelector((state) => state.number.values[stateName]) || "";

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Allow only numbers and decimals
    if (/^\d*\.?\d*$/.test(inputValue)) {
      dispatch(setNumberValue({ key: stateName, value: inputValue }));
    }
  };

  const handleBlur = () => {
    // Convert to float after user finishes input
    dispatch(setNumberValue({ key: stateName, value: parseFloat(value) || 0 }));
  };

  return (
    <div data-field={stateName} className={`mt-3 ${error ? "thick-error-border" : "radio-group-container"}`}>
      <fieldset className="form-section">
        <legend className="mb-3 fw-bold">
          {label}
          {tooltip && <InfoTooltip text={tooltip} />}
        </legend>
        <input
          type="text"
          className="form-control"
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={`Enter your ${label.toLowerCase()}`}
        />
      </fieldset>
    </div>
  );
};

export default NumericInput;
